import { CIcon } from '~/icons/types'
export const ciVerifiedBadge: CIcon = {
  width: 82,
  height: 84,
  paths: [
    {
      d:
        'M73.2 32.3C73.2 14.4 58.8 0 41 0S8.7 14.4 8.7 32.3 23.2 64.5 41 64.5s32.2-14.4 32.2-32.2zm-13.6-4.5L52 35.2l1.8 10.5c.1.5 0 1-.2 1.5-.6 1.1-2 1.6-3.1 1l-9.5-5-9.4 5c-.4.2-1 .3-1.5.2-1.3-.2-2.1-1.4-1.9-2.7L30 35.2l-7.6-7.4c-.4-.4-.6-.8-.7-1.3-.2-1.3.7-2.4 2-2.6l10.5-1.5 4.7-9.5c.2-.3.5-.6.8-.8 1.1-.7 2.6-.3 3.3.8l4.7 9.5 10.5 1.5c.5.1 1 .3 1.3.7 1 .8 1 2.3.1 3.2z'
    },
    {
      d:
        'M11.5 54.2 0 70.7l13.8-2.4c1.2-.2 2.4.6 2.6 1.9L18.9 84l11.5-16.4c-7.6-2.4-14.2-7-18.9-13.4z'
    },
    {
      d:
        'M51.6 67.6 63.1 84l2.4-13.8c.2-1.2 1.4-2.1 2.7-1.9L82 70.8 70.5 54.3c-4.7 6.3-11.4 11-18.9 13.3z'
    }
  ],
  name: 'verified-badge',
  type: 'solid'
}
